<template>
  <div>
      <history-and-more 
      :openHistoryAndMoreModal=historyAndMoreModal 
      :whichSide=choosenSide 
      :roundNumber=roundNumber
      @changeRoundNumber= changeRoundNumber
      @buyTicketModal= openBuyTicketModal
      @HistoryAndMoreModal= closeHistoryAndMoreModal
      @changeSide= changeHistoryAndMore
      @checkRewardModal = openCheckRewardModal
       />
      <buy-ticket :eggsBalance=eggsBalance :lottery=lottery :eggsInstance=eggsToken :roundNumber=roundNumber :buyTicketModal=buyTicketModal @closeBuyTicketModal=closeBuyTicketModal></buy-ticket>
      <check-reward :openCheckRewardModal=checkRewardModal @checkRewardModal= closeCheckRewardModal @openHistoryAndMoreModal = openHistoryAndMoreModal ></check-reward>
        <div class="d-flex flex-column flex-md-row game-screen justify-content-center justify-content-md-between">
            <div class="center d-md-none d-block mt-3">
                <div class="d-flex flex-row justify-content-center">
                    <div class="d-flex justify-content-center">
                        <img class="game-one-entering-scene" src="../assets/images/game1-center.webp" alt="">
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-center buttons-start">
                    <img class="d-none d-md-block" src="../assets/images/wawing-left.webp" alt="">
                    <button v-if="walletConnected" @click="buyTicketModal = true" class="buy-ticket-button-for-lottery">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/connect-and-buy-tickets.webp" alt="">
                            <span>BUY TICKET</span>
                        </div>
                    </button>
                    <button v-else class="connect-wallet-button-for-lottery" @click="walletConnected = true">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/connect-and-buy-tickets.webp" alt="">
                            <span>CONNECT WALLET</span>
                        </div>
                    </button>
                    <img class="d-none d-md-block" src="../assets/images/wawing-right.webp" alt="">
                </div>
                <div v-if="walletConnected" class="d-flex flex-row justify-content-center align-items-center eggs-balance">
                    <span class="mx-1 mx-md-0">Balance: {{ parseFloat(eggsBalance).toFixed(2) }} $EGGS</span>
                    <div class="d-md-none d-flex mx-1">
                        <img width="30px" height="30px" src="../assets/images/wallet.webp" alt="">
                    </div>
                </div>
                <div class="d-md-flex d-none flex-row justify-content-center">
                    <img src="../assets/images/wallet.webp" alt="">
                </div>
            </div>
            <div class="left-information d-flex flex-column justify-content-center">
                <div class="d-flex flex-row justify-content-center">
                    <span class="next-draw-text">next draw</span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span class="remaining-time">
                        <time-count-down
                        :takePlace="'firstGame'"
                        :year="eggPotYear"
                        :month="eggPotMonth"
                        :day="eggPotDay"
                        :hour="eggPotHour"
                        :minute="eggPotMinute"
                        :second="eggPotSeconds"
                        :milisecond="30"
                        :clearInterval="clearInterval"
                        @timesUp= newTime></time-count-down>
                    </span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <img class="hour-glass" src="../assets/images/kum-saati.webp" alt="">
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span class="remaining-time">
                        remaining
                    </span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span class="next-draw-text">
                        prize pot
                    </span>
                </div>
                <div class="d-flex flex-row justify-content-center position-relative">
                    <img class="piggy" src="../assets/images/piggy-blank.png" alt="">
                    <span class="piggy-text">
                        {{ prizePoolInEggs  }} $EGGS
                    </span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span class="next-draw-text">
                        your tickets
                    </span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <span class="tickets-held">
                        tickets held : {{ myTicketIDList.length }}
                    </span>
                    <!-- LastTicketNumberHere -->
                    <!-- <img class="tickets-eggs" src="../assets/images/tickets.webp" alt=""> -->
                    <span class="tickets-held"> {{ myLastTicketNumber }} </span>
                    <span class="tickets-held">total tickets</span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <button @click="openHistoryAndMoreModal('history')" class="btn history-and-details">
                        history
                    </button>
                    <button @click="openHistoryAndMoreModal('more')" class="btn history-and-details">
                        more
                    </button>
                </div>
            </div>
            <div class="center-none-mobil d-none d-md-block">
                <div class="d-flex flex-row justify-content-center">
                    <div class="d-flex justify-content-center">
                        <img class="game-one-entering-scene" src="../assets/images/game1-center.webp" alt="">
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-center buttons-start">
                    <img class="d-none d-xl-block" src="../assets/images/wawing-left.webp" alt="">
                    <button v-if="walletConnected" @click="buyTicketModal = true" class="buy-ticket-button-for-lottery">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/connect-and-buy-tickets.webp" alt="">
                            <span>BUY TICKET</span>
                        </div>
                    </button>
                    <button v-else class="connect-wallet-button-for-lottery" @click="walletConnected = true">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/connect-and-buy-tickets.webp" alt="">
                            <span>CONNECT WALLET</span>
                        </div>
                    </button>
                    <img class="d-none d-xl-block" src="../assets/images/wawing-right.webp" alt="">
                </div>
                <div v-if="walletConnected" class="d-flex flex-row justify-content-center eggs-balance">
                    <span>Balance: {{ parseFloat(eggsBalance).toFixed(2) }} $EGGS</span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <img src="../assets/images/wallet.webp" alt="">
                </div>
            </div>
            <div class="right-information">
                <div class="d-flex flex-row justify-content-center">
                    <span class="next-draw-text">TBC POTS</span>
                </div>
                <div class="d-flex flex-row justify-content-start">
                    <span class="winning-eggs-text">WINNING EGGS</span>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <div class=" d-flex flex-row justify-content-center winner-numbers">
                        <img src="../assets/images/winning-eggs.webp" alt="">
                        <div class="numbers-positioning">
                            <span class="first-winning-number">{{winningNumber[0]}}</span>
                            <span class="second-winning-number">{{winningNumber[1]}}</span>
                            <span class="third-winning-number">{{winningNumber[2]}}</span>
                            <span class="fourth-winning-number">{{winningNumber[3]}}</span>
                            <span class="fifth-winning-number">{{winningNumber[4]}}</span>
                            <span class="sixth-winning-number">{{winningNumber[5]}}</span>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-md-end justify-content-center align-items-center m-3">
                    <button v-if="lotHasPrevious"  @click="getPreviousLottery" class="arrow-button mx-1">
                        <img src="../assets/images/left-arrow.webp" alt="">
                    </button>
                    <div class="round-number">
                        <span> ROUND {{roundNumber}}</span>
                    </div>
                    <button v-if="lotHasNext" @click="getNextLottery" class="arrow-button mx-1">
                        <img src="../assets/images/right-arrow.webp" alt="">
                    </button>
                </div>
                <div class="d-flex flex-row justify-content-start">
                    <div class="d-flex flex-row justify-content-start total-win-styler">
                        <p>MATCH FIRST 1 <br> {{matchFirstOne.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFirst"> ~{{MockupJson[roundNumber].matchFirst.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFirst"> {{MockupJson[roundNumber].matchFirst.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-end">
                    <div class="d-flex flex-row justify-content-end total-win-styler-right">
                        <p>MATCH FIRST 2 <br> {{matchFirstTwo.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchSecond"> ~{{MockupJson[roundNumber].matchSecond.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchSecond"> {{MockupJson[roundNumber].matchSecond.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-start">
                    <div class="d-flex flex-row justify-content-start total-win-styler">
                        <p>MATCH FIRST 3 <br> {{matchFirstThree.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchThird"> ~{{MockupJson[roundNumber].matchThird.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchThird"> {{MockupJson[roundNumber].matchThird.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-end">
                    <div class="d-flex flex-row justify-content-end total-win-styler-right">
                        <p>MATCH FIRST 4 <br> {{matchFirstFour.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFourth"> ~{{MockupJson[roundNumber].matchFourth.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFourth"> {{MockupJson[roundNumber].matchFourth.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-start">
                    <div class="d-flex flex-row justify-content-start total-win-styler">
                        <p>MATCH FIRST 5 <br> {{matchFirstFive.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFifth"> ~{{MockupJson[roundNumber].matchFifth.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchFifth"> {{MockupJson[roundNumber].matchFifth.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
                 <div class="d-flex flex-row justify-content-end">
                    <div class="d-flex flex-row justify-content-end total-win-styler-right">
                        <p>MATCH FIRST 6 <br> {{matchFirstSix.eggs}} $EGGS <br> <span class="total-win" v-if="MockupJson[roundNumber].matchSixth"> ~{{MockupJson[roundNumber].matchSixth.eggsEach}} $EGGS EACH </span>
                        <br> <span class="total-win" v-if="MockupJson[roundNumber].matchSixth"> {{MockupJson[roundNumber].matchSixth.winnerCount}} WINNERS </span></p>
                    </div>
                </div>
               
            </div>
        </div>
        <lottery-doc></lottery-doc>
  </div>
</template>

<script>

import conf from "../conf";
import { ethers, utils } from "ethers";
import BuyTicket from '../components/BuyTicket.vue'
import CheckReward from '../components/CheckReward.vue'
import EggsToken from '../contracts/EGG.json';
import Lottery from '../contracts/Lottery.json';
import LotteryNFT from '../contracts/LotteryNFT.json';
import HistoryAndMore from '../components/HistoryAndMore.vue'
import TimeCountDown from '../components/TimeCountDown.vue'
import LotteryDoc from '../components/LotteryDoc.vue'
import MockupJson from '../../winnerRoundMock.json'

export default {
  components: { HistoryAndMore, BuyTicket, CheckReward, TimeCountDown, LotteryDoc },
    name:'first-game',
    props: ['walletConnected', "eggsBalance"],
    data(){
        return{
            lotteries: {},
            lotteryInfo: {
                x: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                y: 0,
                z: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                q: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                w: [],
                e: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                r: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                t: [],
                lotteryID: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                lotteryStatus: 0,
                prizePoolInEggs: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                costPerTicket: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                prizeDistribution: [],
                startingTimestamp: (new Date()).getTime(),
                closingTimestamp: (new Date()).getTime() + 1000000,
                winningNumbers: ["1", "2", "3", "4", "5", "6"],
            },
            currentLotteryInfo: {
                x: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                y: 0,
                z: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                q: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                w: [],
                e: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                r: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                t: [],
                lotteryID: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                lotteryStatus: 0,
                prizePoolInEggs: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                costPerTicket: "BigNumber { _hex: '0x00', _isBigNumber: true }",
                prizeDistribution: [],
                startingTimestamp: (new Date()).getTime(),
                closingTimestamp: (new Date()).getTime() + 1000000,
                winningNumbers: [],
            },
            lotHasNext: false,
            lotHasPrevious: true,
            matchFirstOne:{
                eggs : 184,
                eggsEachWinner: 0.045,
                winners: 146
            },
            matchFirstTwo:{
                eggs : 275,
                eggsEachWinner: 33,
                winners: 17
            },
            matchFirstThree:{
                eggs : 459,
                eggsEachWinner: 254.2,
                winners: 2
            },
            matchFirstFour:{
                eggs : 918,
                eggsEachWinner: 0,
                winners: 0
            },
            matchFirstFive:{
                eggs : 1835,
                eggsEachWinner: 0,
                winners: 0
            },
            matchFirstSix:{
                eggs : 3671,
                eggsEachWinner: 1,
                winners: 40619
            },
            winningNumber: 111111,
            provider: null,
            roundNumber: 2,
            currentRoundNumber: 2,
            historyAndMoreModal : false,
            buyTicketModal: false,
            checkRewardModal: false,
            choosenSide : 'history',
            prizePoolInEggs: 0,
            eggPotYear: 2022,
            eggPotMonth: 6,
            eggPotDay: 13,
            eggPotHour: 11,
            eggPotMinute: 59,
            eggPotSeconds:59,
            clearInterval:false,
            myTicketIDList: [],
            myLastTicketNumber: "000000",
            MockupJson: MockupJson,
        }       
    },
    beforeCreate(){
        document.body.style.background = '#010208'
    },
    beforeDestroy(){
        document.body.style.background = ''
    },
    computed: {
        eggsToken () {
            // console.log(["Eggs Contract:", conf.eggsTokenAddress])
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return new ethers.Contract( conf.eggsTokenAddress, EggsToken.abi, this.provider.getSigner())
        },
        lottery () {
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return new ethers.Contract( conf.lotteryAddress, Lottery.abi, this.provider.getSigner())
        },
        lotteryNFT () {
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return new ethers.Contract( conf.lotteryNFTAddress, LotteryNFT.abi, this.provider.getSigner())
        }
    },
    created(){
        // console.log(this.walletConnected)
    },
    methods:{
        initiate(){
            if (this.walletConnected && this.eggsBalance !== 0){
                // console.log("getting balance")
                this.getEggsBalance()
            }
            this.getCurrentLotteryInfo();
            this.getTicketList()
        },
        async getTicketList(){
            await this.lotteryNFT.getUserTickets(this.roundNumber, ethereum.selectedAddress).then((result) => {this.myTicketIDList = result.map((tick) => {return tick.toString()})})
            // after got ticker list lets findout myLastTicketId
            // console.log(this.myTicketIDList)
            let lastTicketId = this.myTicketIDList[this.myTicketIDList.length - 1]
            // console.log(lastTicketId)
            this.myLastTicketNumber = await this.getTicketNumbers(lastTicketId)
            // console.log(this.myLastTicketNumber)
            
        },
        async getTicketNumbers(ticketId){
            let number = await this.lotteryNFT.getTicketNumbers(ticketId)
            return number.join("")
        },
        async getEggsBalance(){
            let balance;
            await this.eggsToken.balanceOf(ethereum.selectedAddress).then((result) => {balance = utils.formatEther(result)})
            // console.log(`BALANCE: ${balance}`)
            // console.log(`contract address: ${conf.eggsTokenAddress}`)
            this.$emit('eggsBalance' , balance)
        },
        async getCurrentLotteryInfo(){
            await this.lottery.getBasicLottoInfo(this.currentRoundNumber)
            .then((result) => {
                    this.lotteries[this.currentRoundNumber] = result
                    this.currentLotteryInfo = result
                    let endDate = new Date(parseInt(result.closingTimestamp.toNumber()))
                    this.eggPotYear = endDate.getFullYear()
                    this.eggPotMonth = endDate.getMonth()
                    this.eggPotDay = endDate.getDate()
                    this.eggPotHour= endDate.getHours()
                    this.eggPotMinute= endDate.getMinutes()
                    this.eggPotSeconds= endDate.getSeconds()
                    this.prizePoolInEggs=utils.formatEther(result.prizePoolInCake)
                })
        },
        async getLotteryInfo(){
            this.lotteryInfo = this.lotteries[this.roundNumber]
            if (this.lotteryInfo != undefined){
                return
            }
            await this.lottery.getBasicLottoInfo(this.roundNumber)
            .then((result) => {
                this.lotHasNext = false
                this.lotHasPrevious = this.roundNumber > 1
                this.lotteries[this.roundNumber] = result
                if (result.lotteryStatus < 2){
                    this.winningNumber="      "
                }else{
                    this.winningNumber=result.winningNumbers.join("")
                }
                this.prizePoolInEggs=utils.formatEther(result.prizePoolInCake)
                let prizePool = result[4]
                // prizes for matches
                this.matchFirstOne.eggs = (this.prizePoolInEggs / 100) * prizePool[0]
                this.matchFirstTwo.eggs = (this.prizePoolInEggs / 100) * prizePool[1]
                this.matchFirstThree.eggs = (this.prizePoolInEggs / 100) * prizePool[2]
                this.matchFirstFour.eggs = (this.prizePoolInEggs / 100) * prizePool[3]
                this.matchFirstFive.eggs = (this.prizePoolInEggs / 100) * prizePool[4]
                this.matchFirstSix.eggs = (this.prizePoolInEggs / 100) * prizePool[5]
                // put match winners count here
                // this.matchFirstOne.winners = (this.prizePoolInEggs / 100) * prizePool[0]
                // this.matchFirstTwo.winners = (this.prizePoolInEggs / 100) * prizePool[1]
                // this.matchFirstThree.winners = (this.prizePoolInEggs / 100) * prizePool[2]
                // this.matchFirstFour.winners = (this.prizePoolInEggs / 100) * prizePool[3]
                // this.matchFirstFive.winners = (this.prizePoolInEggs / 100) * prizePool[4]
                // this.matchFirstSix.winners = (this.prizePoolInEggs / 100) * prizePool[5]
                // put eggs each winner here
                // this.matchFirstOne.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[0]
                // this.matchFirstTwo.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[1]
                // this.matchFirstThree.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[2]
                // this.matchFirstFour.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[3]
                // this.matchFirstFive.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[4]
                // this.matchFirstSix.eggsEachWinner = (this.prizePoolInEggs / 100) * prizePool[5]
                })
            // console.log(`contract address: ${conf.eggsTokenAddress}`)
            // this.$emit('eggsBalance' , balance)
        },
        newTime(value){
            value.setHours(value.getHours() + 12)
            this.eggPotYear = value.getFullYear()
            this.eggPotMonth= value.getMonth()
            this.eggPotDay= value.getDate()
            this.eggPotHour= value.getHours()
            this.eggPotMinute= value.getMinutes()
            this.eggPotSeconds= value.getSeconds()
        },
        openHistoryAndMoreModal(whichSide){
            this.historyAndMoreModal = true
            this.choosenSide = whichSide
        },
        closeBuyTicketModal(value){
            this.buyTicketModal = value
        },
        closeCheckRewardModal(value){
            this.checkRewardModal = value
        },
        closeHistoryAndMoreModal(value){
            this.historyAndMoreModal = value
        },
        changeHistoryAndMore(value){
            this.choosenSide = value
        },
        openCheckRewardModal(value){
            this.checkRewardModal = value
        },
        openBuyTicketModal(value){
            this.buyTicketModal = value
        },
        changeRoundNumber(value){
            this.roundNumber = value
        },
        getNextLottery(){
            this.roundNumber += 1
            this.getLotteryInfo()
            console.log(this.lotteries[this.roundNumber])
        },
        getPreviousLottery(){
            this.roundNumber -= 1
            this.getLotteryInfo()
        }
    },
    mounted() {
        this.initiate()
    }
}
</script>

<style scoped>
.game-screen{
    padding: 60px;
}
.next-draw-text{
    font-size: 42px;
    color: #FFCC00;
}
.piggy-text{
    color: black;
    font-size: 23px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.piggy{
    margin-left: 7px;
}
.information-cards{
    width: 431px;
    height: 293px;
    margin: 69px 45px 29px 45px;
    border-radius: 54px;
    border: solid 6px #ffe371;
    background-color: #172449;
}
.information-card-header{
    font-size: 24px;
    color: #ffcd00;
    text-align: center;
    margin: 10px 0;
}
.eggs-balance{
    font-size: 40px;
    color: white;
}
.information-card-text{
    font-size: 24px;
    color: #fff;
    text-align: start;
    margin-left: 29px;
}
.information-text{
    margin-left: 35px;
    color: #fff;
    font-size: 24px;
    min-width: 453px;
}
.information-text-second h3{
    text-decoration: underline;
    font-size: 30px;
    color: #ffe371;
}
.information-text-second{
    color: #fff;
    font-size: 24px;
    padding: 0 10px;
}
.information-text-second h1{
    font-size: 48px;
    margin-bottom: 26px;
    color: #ffcd00;
}
.information-text h1{
    font-size: 48px;
    margin-bottom: 26px;
    color: #ffcd00;
}
.information-card-text span{
    color: #ffe371;
}
.eggpot-information-header{
    color: #fff;
    font-size: 100px;
}
.tickets-held{
    width: 76px;
    margin: 3px 14px;
    text-align: center;
    font-size: 19px;
    color: #fff;
 
}
.total-win-styler{
    font-size: 21.5px;
    line-height: 18px;
    color: white;
    margin-left: 34px;
    text-align: left;
}
.total-win-styler-right{
    font-size: 21.5px;
    line-height: 18px;
    color: white;
    margin-right: 34px;
    text-align: right;
}
.total-win{
    color: #fcdf6b;
}
.arrow-button{
    background: #2a396f;
    border: none;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    width: 29px;
    height: 36px;
}
.round-number{
    background: #2a396f;
    border: none;
    color: white;
    border-radius: 14px;
    width: 135px;
    font-size: 27px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 37px;
}
.round-number span{
    height: 100%;
    line-height: 37px;
}
.buttons-start{
    margin-top: 50px;
}
.buy-ticket-button-for-lottery{
    background: none;
    border: none;
}
.buy-ticket-button-for-lottery span{
    position: absolute;
    color: #907242;
    font-size: 48px;
}
.buy-ticket-button-for-lottery:hover{
    text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287;
}
.connect-wallet-button-for-lottery{
    background: none;
    border: none;
}
.connect-wallet-button-for-lottery span{
    position: absolute;
    color: #907242;
    font-size: 35px;
    margin-top: 10px;
}
.connect-wallet-button-for-lottery:hover{
    text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287;
}
.connect-wallet-information{
    color: #fff;
    font-size: 43px;
}
.win-big{
    color: #fff;
    position: absolute;
    bottom: 10px;
    font-size: 30px;
}
.eggpot-header{
    color: #fff;
    position: absolute;
    font-size: 90px;
    top: 0%;
    line-height: 75px;
}
.eggpot-header-mobile{
    color: #fff;
    position: absolute;
    font-size: 90px;
    line-height: 60px;
}
.history-and-details{
    background-color: #2a396f;
    border-radius: 19px;
    border: none;
    margin: 46px;
    color: white;
    font-size: 23px;
    width: 147px;
    height: 45px;
    padding: 0 30px;
}
.remaining-time{
    font-size: 36px;
    color: white;
}
.left-information{
    width: 430px;
    height: 831px;
    border: solid 6px #ffe371;
    background-color: #0a0e1c;
    border-radius: 54px;
    margin-left: 40px;
}
.right-information{
    width: 430px;
    height: 831px;
    border: solid 6px #ffe371;
    background-color: #0a0e1c;
    border-radius: 54px;
    margin-right: 40px;
}
.winning-eggs-text{
    font-size: 27px;
    color: #fcdf6b;
    margin-left: 39px;
}
.winner-numbers{
    color: black;
    font-size: 44px;
    position: relative;
}
.first-winning-number{
    position: absolute;
    left: 4%;
    width: 20px;
    text-align: center;
}
.second-winning-number{
    position: absolute;
    left: 21%;
    width: 20px;
    text-align: center;
}
.third-winning-number{
    position: absolute;
    left: 38%;
    width: 20px;
    text-align: center;
}
.fourth-winning-number{
    position: absolute;
    left:55%;
    width: 20px;
    text-align: center;
}
.fifth-winning-number{
    position: absolute;
    left: 73%;
    width: 20px;
    text-align: center;
}
.sixth-winning-number{
    position: absolute;
    left: 90%;
    width: 20px;
    text-align: center;
}
.how-can-you-win{
    width: 405px;
    height: 285px;
    border-radius: 43px;
    border: solid 4.4px #ffe371;
}
.winning-version{
    font-size: 30px;
    color: #ffe371;
    margin: 31px 0 0 45px;
}
.winning-matched-numbers{
    border-radius: 9px;
    border: solid 1px #ffcd00;
    width: 92px;
    height: 26px;
    position: relative;
    margin: 40px 0 0 42px;
}
.winning-matched-numbers-inside{
    position: absolute;
    letter-spacing: 7px;
    font-size: 30px;
    left: 5px;
    bottom: -6px;
}
.winning-unmatched-numbers{
    margin: 27px 0 0 5px;
    letter-spacing: 7px;
    font-size: 30px;
}
.winning-information{
    width: 100px;
    font-size: 18px;
    margin: 38px 0 0 17px;
    color: #ffe371;
    line-height: 0.89;
}
.winning-numbers{
    margin: 20px 0 0 17px;
}
.winning-unmatched-numbers-under{
    margin-left: 7px;
}
.winning-matched-numbers-under{
    margin-left: -45px;
}
.losing-matched-numbers{
    border-radius: 9px;
    border: solid 1px #ffcd00;
    width: 117px;
    height: 26px;
    position: relative;
    margin: 40px 0 0 0;
}
.losing-matched-numbers-inside{
    position: absolute;
    letter-spacing: 7px;
    font-size: 30px;
    left: 5px;
    bottom: -6px;
}
.winning-probilities{
    width: 785px;
    height: 225px;
    border-radius: 63px;
    border: solid 4.4px #ffe371;
    font-size: 24px;
    color: #ffe371;
    line-height: 1.25;
    padding: 24px 18px;
}
.losing-unmatched-numbers{
    margin: 27px 0 0 42px;
    letter-spacing: 5px;
    font-size: 30px;
}
.losing-unmatched-numbers-under{
    margin-left: -50px;
}
.losing-matched-numbers-under{
    margin-left: 12px;
}
.losing-matched-numbers-under-three{
    margin-left: 2px;
}
@media (max-width : 1400px) {
    .left-information , .right-information{
        margin: 10px auto;
        width: 286px;
        height: 584px;
    }
    .game-screen {
        padding: 60px 0;
    }
    .center-none-mobil{
        width: 25%;
    }
    .game-one-entering-scene{
        width: 270px;
    }
    .hour-glass{
        width: 65px;
        height: 100px;
    }
    .piggy{
        width: 130px;
        height: 100px;
    }
    .tickets-eggs{
        width: 116px;
        height: 42px;
    }
    .tickets-held{
        font-size: 15px;
    }
    .history-and-details{
        margin: 20px auto;
        width: 120px;
        height: 30px;
        font-size: 15px;
    }
    .game-one-entering-scene{
        width: 252px;
        margin: 0 auto;
    }
    .win-big{
        font-size: 25px;
    }
    .winner-numbers{
        font-size: 27px;
    }
    .winner-numbers img{
        width: 100%;
        margin-top: -5px;
    }
    .total-win-styler , .total-win-styler-right{
        font-size: 15px;
        line-height: 11px;
    }
    .eggpot-information-header{
        font-size: 35px;
    }
    .information-cards{
        width: 287px;
        height: 195px;
    }
    .information-card-header{
        font-size: 20px;
    }
    .information-card-text{
        font-size: 17px;
    }
    .how-can-you-win{
        width: 350px;
    }
    .winning-numbers{
        width: 235px;
    }
    .winning-information{
        font-size: 16px;
    }
    .winning-matched-numbers-inside {
        font-size: 23px;
        bottom:-4px
    }
    .winning-unmatched-numbers {
        font-size: 23px;
        margin-top: 33px;
    }
    .winning-matched-numbers-under{
        margin-left: -10px;
    }
    .losing-unmatched-numbers-under{
        margin-left: 0;
    }
    .losing-matched-numbers-inside{
        font-size: 23px;
        left: 8px;
        bottom: -5px;
    }
    .losing-unmatched-numbers{
        font-size: 23px;
        margin-top: 35px;
    }
    .eggpot-header{
        font-size: 50px;
        line-height: 50px;
    }
    .eggpot-header-mobile{
        font-size: 50px;
        line-height: 50px;
    }
    .next-draw-text{
        font-size: 28px;
    }
    .remaining-time{
        font-size: 24px;
    }
    .right-information{
        margin: 20px auto;
    }
    .connect-wallet-information{
        font-size: 25px;
    }
    .information-cards{
        margin: 20px auto;
    }
}
@media (max-width : 780px) {
    .left-information , .right-information{
        margin: 10px auto;
        width: 286px;
        height: 584px;
    }
    .game-screen{
        padding: 0;
    }
    .eggs-balance{
        font-size: 30px;
    }
    .piggy-text{
        font-size: 20px;
    }
    .buy-ticket-button-for-lottery img{
        width: 90%;
    }
    .buy-ticket-button-for-lottery span{
        font-size: 40px;
    }
    .connect-wallet-button-for-lottery img{
        width: 90%;
    }
    .connect-wallet-button-for-lottery span{
        font-size: 30px;
    }
    .hour-glass{
        width: 65px;
        height: 100px;
    }
    .piggy{
        width: 130px;
        height: 100px;
    }
    .tickets-eggs{
        width: 116px;
        height: 42px;
    }
    .tickets-held{
        font-size: 15px;
    }
    .history-and-details{
        margin: 20px auto;
        width: 120px;
        height: 30px;
        font-size: 15px;
    }
    .game-one-entering-scene{
        width: 252px;
        margin: 0 auto;
    }
    .win-big{
        font-size: 25px;
    }
    .winner-numbers{
        font-size: 27px;
    }
    .winner-numbers img{
        width: 85%;
        margin-top: 0px;
    }
    .first-winning-number{
        left: 10%;
    }
    .second-winning-number{
        left: 25%;
    }
    .third-winning-number{
        left: 39%;
    }
    .fourth-winning-number{
        left: 53.5%;
    }
    .fifth-winning-number{
        left: 68%;
    }
    .sixth-winning-number{
        left: 83%
    }
    .total-win-styler , .total-win-styler-right{
        font-size: 15px;
        line-height: 11px;
    }
    .eggpot-information-header{
        font-size: 35px;
    }
    .information-cards{
        width: 287px;
        height: 195px;
    }
    .information-card-header{
        font-size: 20px;
    }
    .information-card-text{
        font-size: 17px;
    }
    .how-can-you-win{
        width: 350px;
    }
    .winning-numbers{
        width: 235px;
    }
    .winning-information{
        font-size: 16px;
    }
    .winning-matched-numbers-inside {
        font-size: 23px;
        bottom:-4px
    }
    .winning-unmatched-numbers {
        font-size: 23px;
        margin-top: 33px;
    }
    .winning-matched-numbers-under{
        margin-left: -10px;
    }
    .losing-unmatched-numbers-under{
        margin-left: 0;
    }
    .losing-matched-numbers-inside{
        font-size: 23px;
        left: 8px;
        bottom: -5px;
    }
    .losing-unmatched-numbers{
        font-size: 23px;
        margin-top: 35px;
    }
    .eggpot-header{
        font-size: 50px;
        line-height: 50px;
    }
    .eggpot-header-mobile{
        font-size: 50px;
        line-height: 50px;
    }
    .next-draw-text{
        font-size: 28px;
    }
    .remaining-time{
        font-size: 24px;
    }
    .right-information{
        margin: 20px auto;
    }
    .connect-wallet-information{
        font-size: 25px;
    }
    .information-cards{
        margin: 20px auto;
    }
}

</style>